import api from "../middlware/api";
import { BASE_URL } from "../constants";
import {DepartmentFormData } from "../interfaces/departments";
import { camelToSnake } from "../utils/CamelToSnake";

// CREATE Department
export const createDepartment = (payload: DepartmentFormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/departments`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all Departments
export const getDepartments = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/departments`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET single Department
export const getDepartmentById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/departments/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// UPDATE Department
export const updateDepartment = (
  id: number | string,
  payload: DepartmentFormData
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/departments/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
